export const Year = () => new Date().getFullYear();
